// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slug-item {
    cursor: pointer;
    width: 100%;
    border-top: 1px solid #c1c0c0;
    padding-top: 0.5rem;
}


/* .slug-item:hover{
 background: #ceecf7;
} */


/* .slug-title{
    color: #008fc7
} */

.overflow-scroll {
    max-height: 200px;
    overflow-y: auto;
    overflow-x: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/app/site-menu/pages-slugs/pages-slugs.component.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,WAAW;IACX,6BAA6B;IAC7B,mBAAmB;AACvB;;;AAGA;;GAEG;;;AAGH;;GAEG;;AAEH;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":[".slug-item {\r\n    cursor: pointer;\r\n    width: 100%;\r\n    border-top: 1px solid #c1c0c0;\r\n    padding-top: 0.5rem;\r\n}\r\n\r\n\r\n/* .slug-item:hover{\r\n background: #ceecf7;\r\n} */\r\n\r\n\r\n/* .slug-title{\r\n    color: #008fc7\r\n} */\r\n\r\n.overflow-scroll {\r\n    max-height: 200px;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
